import { Input, Select } from "antd";
import Header from "../../common/Header/header";
import React from "react";
import Loading from "../../common/Loading/loading";
import { useNavigate } from "react-router-dom";
import preve_arrow from "../../../images/prve-arrow.png";
const PresidentDetailsComponent = (props) => {
  const {
    wing_section,
    flat_section,
    handleChangeWing,
    handleChangeflat,
    handleChangeGender, 
    addPresident,
    userError,
    handelAddPresident,
    handleComfirm,
    addPresidentData,
    id,
    presidentID,
    handelUpdatePresidentDetails,
  } = props;
  const navigate = useNavigate();

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];

  return (
    <>
      <Header title="Dashboard" />
      <div className="header-title" onClick={() => navigate("/society-list")}>
        <img src={preve_arrow} alt="preve_arrow" className="preve_arrow" />
        <span>{id ? "Society List " : "Society List"}</span>
      </div>
      <div className="Society-container">
        <div
          className={
            !presidentID ? "president-right-content" : "edit-right-content"
          }
        >
          <h2>President Details</h2>
          <div className="president-right">
            <div className="president-register-form">
              <div className="child-container">
                <p className="input-title">President Name</p>
                <Input
                  size="large"
                  className="input-field"
                  placeholder="Enter President Name"
                  name="name"
                  onChange={handelAddPresident}
                  value={addPresident?.name}
                />
                {userError.name && (
                  <p className="error-message">{userError.name}</p>
                )}
              </div>
              <div className="child-container">
                <p className="input-title">Phone Number</p>
                <div className="select-country-number">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg"
                    alt="Indian Flag"
                    style={{ width: 20, marginRight: 4 }}
                  />
                  <span style={{ marginRight: 8, color: "#555" }}>+91</span>
                  <input
                    onChange={handelAddPresident}
                    name="phone_number"
                    placeholder=""
                    style={{ border: "none", outline: "none", flex: 1 }}
                    value={addPresident.phone_number}
                    maxLength={10}
                  />
                </div>
                {userError.phone_number && (
                  <p className="error-message">{userError.phone_number}</p>
                )}
              </div>

              <div className="child-container">
                <p className="input-title">Email Address</p>
                <Input
                  className="input-field"
                  placeholder="Enter Email Address"
                  name="email"
                  onChange={handelAddPresident}
                  value={addPresident.email}
                />
                {userError.email && (
                  <p className="error-message">{userError.email}</p>
                )}
              </div>

              <div className="child-container">
                <p className="input-title">Login PIN</p>
                <Input
                  className="input-field"
                  placeholder="****"
                  name="code"
                  onChange={handelAddPresident}
                  maxLength={4}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={addPresident.code}
                />

                {userError.code && (
                  <p className="error-message">{userError.code}</p>
                )}
              </div>
              <div className="child-container">
                <p className="input-title">Wing</p>
                <Select
                  placeholder="Select President Wing"
                  optionFilterProp="label"
                  name="wingName"
                  onChange={(e) => handleChangeWing(e, "wing")}
                  options={wing_section}
                  value={addPresident.wingName || undefined}
                  className="custom-select"
                />
                {userError.wingName && (
                  <p className="error-message">{userError.wingName}</p>
                )}
              </div>
              <div className="child-container">
                <p className="input-title">Flat Number.</p>
                <Select
                  placeholder="Select President Flat Number"
                  optionFilterProp="label"
                  name="flatName"
                  onChange={(e) => handleChangeflat(e, "flat")}
                  options={flat_section}
                  value={addPresident.flatName || undefined}
                  className="custom-select"
                />
                {userError.flatName && (
                  <p className="error-message">{userError.flatName}</p>
                )}
              </div>
              <div className="child-container">
                <p className="input-title">Gender</p>
                <Select
                  placeholder="Select Gender"
                  optionFilterProp="label"
                  name="gender"
                  onChange={handleChangeGender}
                  options={genderOptions}
                  value={addPresident.gender || undefined}
                  className="custom-select" 
                />
                {userError.gender && (
                  <p className="error-message">{userError.gender}</p>
                )}
              </div>
            </div>
            <div className="btn-container">
              {!id ? (
                <button onClick={handleComfirm}>
                  {addPresidentData ? (
                    <Loading type="spinner" color="#fff" />
                  ) : (
                    "Add President"
                  )}
                </button>
              ) : (
                <button onClick={handelUpdatePresidentDetails}>
                  {presidentID ? "Edit President" : "Add President"}
                </button>
              )}
            </div>
            <div className="description-container"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PresidentDetailsComponent;
